var classes = {
  "day": "m_396ce5cb"
};
export { classes as default };